import { handleRequest } from "../../axios";
import { axiosInstance } from "./JsdhNotifikaceService";
import {
    ADMIN_EMAIL_CONFIG_STATUS_URL,
    ADMIN_EMAIL_LOG_URL,
    ADMIN_EMAIL_TEST_URL,
} from "../url";
import type { EmailConfigStatus, EmailLogEntry, SendTestEmailRequest } from "../generated/models/EmailNastaveni";

const getEmailConfigStatus = () => {
    return handleRequest<EmailConfigStatus>(() =>
        axiosInstance.get(ADMIN_EMAIL_CONFIG_STATUS_URL)
    );
};

const getEmailLog = (params?: { limit?: number; offset?: number }) => {
    return handleRequest<EmailLogEntry[]>(() =>
        axiosInstance.get(ADMIN_EMAIL_LOG_URL, { params })
    );
};

// BE AdminEmailController čte body.get("to") — klíč musí být "to".
const sendTestEmail = (data: SendTestEmailRequest) => {
    return handleRequest<{ success: boolean; message?: string }>(() =>
        axiosInstance.post(ADMIN_EMAIL_TEST_URL, data)
    );
};

const EmailNastaveniService = {
    getEmailConfigStatus,
    getEmailLog,
    sendTestEmail,
};

export default EmailNastaveniService;
